/**
 * @fileoverview PUT handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/timing/quiet_hours" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursCacheKeys } from "./constants";
import type {
  PutDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursProps,
  PutDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult,
} from "./types";

export const putDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHours = reactQueryMutationAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursCacheKeys,
  (
    props: PutDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursProps
  ): Promise<PutDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult> => {
    const { appGroupId, dsaId, start_time, end_time, signal } = props;
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/timing/quiet_hours`,
      "PUT",
      {
        start_time,
        end_time,
      },
      signal ? { signal } : undefined,
      { propagateFetchRequestError: false }
    );
  }
);
